import { LawFirmListItemDto, LawFirmStatisticsDto } from 'types/law-firms';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APILawFirmsSlice = portalAPI
    .enhanceEndpoints({
        addTagTypes: ['LawFirms', 'LawFirmStatistics'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getLawFirmStatistics: builder.query<LawFirmStatisticsDto, void>({
                query: () => '/v1/law-firms/statistics',
                providesTags: ['LawFirmStatistics'],
            }),
            getLawFirmsWithFilters: accumulatedQueryWithFilters<LawFirmListItemDto>(builder, '/v1/law-firms', {
                providesTags: ['LawFirms'],
            }),
        }),
        overrideExisting: false,
    });

export const { useGetLawFirmStatisticsQuery, useLazyGetLawFirmsWithFiltersQuery } = APILawFirmsSlice;
